import React, { useState, useRef, useEffect } from 'react';
import { ContentHeader } from '@components';
import { Button } from 'react-bootstrap';
import GoogleMapReact from 'google-map-react';
import { Form } from 'react-bootstrap';
import { DateTimePicker, TimePicker } from 'react-tempusdominus-bootstrap';
import { logoutUser } from '@store/reducers/auth';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-toastify/dist/ReactToastify.css';
import SignatureCanvas from 'react-signature-canvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { Table } from 'react-bootstrap';
import { fetchDropdownData, ReNewShopData, submitFormReNewShopData } from '../../services/apifp';
import { SearchBox } from './SearchBox';

const autocompleteStyles = `
  .pac-container { z-index: 200000 !important; }
  #map-container .map-search-container {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 200001;
    width: calc(100% - 20px);
    max-width: 600px;
    padding: 0 8px;
  }
  #map-container .selected-box-container {
    position: absolute;
    left: 10px;
    bottom: 10px;
    z-index: 200001;
    width: 320px;
  }
  @media (max-width: 576px) {
    #map-container .map-search-container {
      left: 5%;
      width: 100%;
      top: 8px;
    }
    #map-container .selected-box-container {
      left: 5%;
      width: 90%;
      bottom: 8px;
      max-width: none;
    }
  }
`;

export default function RenewShop() {
  const _tk = localStorage.getItem('gatekeeper_token');
  const user = useSelector((state: any) => state.auth.currentUser);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    shopIdOld: '',
    name: '', //ชื่อนิติบุคคล/ชื่อบุคคล
    taxId: '', //เลขผู้เสียภาษี/เลขบัตรประชาชน
    installationPoint: '', //ชื่อจุดติดตั้ง
    contactPerson: '', //ผู้กระทำการแทน
    phone: '', //เบอร์โทรศัพท์
    email: '', //อีเมล์
    contactPerson2: '', //บุคคลติดต่อ2
    addressByIdCard: "", // ที่อยู่ตามบัตรประชาชน/ภ.พ.20
    address: '', //ที่อยู่จุดติดตั้ง
    gpsLocation: '', //GPS Location
    rewardType: '', //ชนิดผลตอบแทนจ่าย
    shopType: '', //ชนิดร้านค้า
    installDate: new Date().toISOString().split('T')[0], //ประมาณการวันที่ติดตั้ง
    startDate: new Date().toISOString().split('T')[0], // วันที่เริ่มต้นสัญญา (ค่าเริ่มต้นเป็นวันนี้)
    endDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1) - 86400000)
      .toISOString()
      .split('T')[0], // วันที่สิ้นสุดสัญญา (+1 ปี)
    rentalFee: '', //ค่าเช่า
    machinesNumber: '', //
    msd: '', //เลือก MSD
    bank: '', //เลือกธนาคาร
    bankAccount: '', //เลขที่บัญชีธนาคาร
    workDays: '', //
    workHourStart: '', // ✅ เริ่มต้นเป็น null รองรับ DateTimePicker
    workHourEnd: '', // ✅ เริ่มต้นเป็น null รองรับ DateTimePicker
  });

  const navigate = useNavigate();

  const [dropdownData, setDropdownData] = useState<DropdownData>({
    BANK: { DATA: [] },
    PAYMENT: { DATA: [] },
    SHOP_TYPE: { DATA: [] },
    MSD: { DATA: [] },
    SHOP_WORKING_DAY: { DATA: [] },
  });

  interface DropdownOption {
    value: string;
    label: string;
  }

  interface DropdownData {
    BANK: { DATA: DropdownOption[] };
    PAYMENT: { DATA: DropdownOption[] };
    SHOP_TYPE: { DATA: DropdownOption[] };
    MSD: { DATA: DropdownOption[] };
    SHOP_WORKING_DAY: { DATA: DropdownOption[] };
  }

  useEffect(() => {
    const loadDropdownData = async () => {
      try {
        const data = await fetchDropdownData();
        setDropdownData({
          BANK: data.BANK || { DATA: [] },
          PAYMENT: data.PAYMENT || { DATA: [] },
          SHOP_TYPE: data.SHOP_TYPE || { DATA: [] },
          MSD: data.MSD || { DATA: [] },
          SHOP_WORKING_DAY: data.SHOP_WORKING_DAY || { DATA: [] },
        });
      } catch (error) {
        console.error('Error fetching dropdown data:', error);
      }
    };
    loadDropdownData();
  }, []);

  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [showSearchModal, setShowSearchModal] = useState(false);

  const handleSearch = async () => {
    if (!searchQuery.trim()) {
      toast.error('กรุณาใส่คำค้นหา');
      return;
    }
    try {
      const response = await ReNewShopData(searchQuery);
      if (response && response.length > 0) {
        setSearchResults(response);
        setShowSearchModal(true);
      } else {
        toast.info('ไม่พบข้อมูลร้านค้า');
      }
    } catch (error) {
      console.error(" Error fetching shop data:", error);
      toast.error('เกิดข้อผิดพลาดในการค้นหาร้านค้า');
      dispatch(logoutUser());
      window.location.href = "/login";
    }
  };

  const handleSelectShop = (shop: any) => {
    setFormData({
      ...formData,
      shopIdOld: shop.SHOP_ID,
      name: shop.SHOP_TAX_NAME_TH || '',
      taxId: shop.ID_TAX || '',
      installationPoint: shop.SHOP_NAME_TH || '',
      contactPerson: shop.CONTACT_NAME_TH || '',
      phone: shop.MOBILE || '',
      email: shop.EMAIL || '',
      contactPerson2: shop.CONTACT_NAME_TH2 || '',
      addressByIdCard: shop.ADDRESS_TAX || '',
      address: shop.ADDRESS || '',
      gpsLocation: shop.GPS || '',
      rewardType: shop.CAL_TYPE || '',
      shopType: shop.SHOP_TYPE || '',
      installDate: shop.DATE_INSTALL || new Date().toISOString().split('T')[0],
      startDate: shop.DATE_START || new Date().toISOString().split('T')[0],
      endDate: shop.DATE_END || new Date(new Date().setFullYear(new Date().getFullYear() + 1) - 86400000)
        .toISOString()
        .split('T')[0],
      rentalFee: shop.RENTAL_FEE || '',
      machinesNumber: shop.MACHINES_NUMBER || '',
      msd: shop.MSD || '',
      bank: shop.BANK || '',
      bankAccount: shop.ACC_ID || '',
      workDays: shop.WORK_DAYS || '',
      workHourStart: shop.WORK_HOUR_START ? shop.WORK_HOUR_START.substring(0, 5) : null,
      workHourEnd: shop.WORK_HOUR_END ? shop.WORK_HOUR_END.substring(0, 5) : null,
    });

    if (shop.GPS) {
      const parts = shop.GPS.split(',');
      setMyposition((prev) => ({ ...prev, center: { lat: Number(parts[0]), lng: Number(parts[1]) } }));
    }
    setShowSearchModal(false);
  };

  const [errorFields, setErrorFields] = useState<string[]>([]);
  const isFormValid = () => {
    const requiredFields = ["name", "rewardType", "msd", "shopType", "gpsLocation", "bank", "workDays"];
    const invalidFields = requiredFields.filter((field) => !formData[field]);
    setErrorFields(invalidFields);
    return invalidFields.length === 0;
  };

  const [showMap, setShowMap] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const mapContainerRef = useRef(null);

  useEffect(() => {
    const checkFullscreen = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener("fullscreenchange", checkFullscreen);
    return () => document.removeEventListener("fullscreenchange", checkFullscreen);
  }, []);

  const handleMapClick = ({ lat, lng }: { lat: number; lng: number }) => {
    setMyposition({ center: { lat, lng }, zoom: myposition.zoom });
    setFormData((prevState) => ({ ...prevState, gpsLocation: `${lat.toFixed(6)},${lng.toFixed(6)}` }));
  };

  const toggleFullscreen = () => {
    const mapContainer = document.getElementById("map-container");
    if (!document.fullscreenElement) {
      mapContainer?.requestFullscreen().catch((err) => console.error("Fullscreen error:", err));
    } else {
      document.exitFullscreen();
    }
  };

  const handleConfirmLocation = () => {
    if (formData.gpsLocation) {
      toast.success(`ตำแหน่งที่เลือก: ${formData.gpsLocation}`);
      setShowMap(false);
    } else {
      toast.error('กรุณาเลือกตำแหน่งบนแผนที่');
    }
  };

  function Marker({ lat, lng }: { lat: number; lng: number }) {
    return (
      <div style={{ position: 'absolute', transform: 'translate(-50%, -50%)', color: 'red', fontSize: '24px' }}>
        <FontAwesomeIcon icon={fas.faMapMarkerAlt} />
      </div>
    );
  }

  const [myposition, setMyposition] = useState({
    center: { lat: 13.545550016333902, lng: 100.96180662698616 },
    zoom: 17,
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => setMyposition((prev) => ({ ...prev, center: { lat: position.coords.latitude, lng: position.coords.longitude } })),
        (error) => {
          console.error("ไม่สามารถดึงตำแหน่งได้: ", error);
          alert("ไม่สามารถดึงตำแหน่งได้ ใช้ตำแหน่งเริ่มต้นแทน");
        }
      );
    } else {
      alert("เบราว์เซอร์ของคุณไม่รองรับการดึงตำแหน่งปัจจุบัน");
    }
  }, []);

  const mapRef = useRef<any>(null);
  const mapApi = useRef<any>(null);
  const apiReady = useRef(false);
  const [mapInstance, setMapInstance] = useState<any>(null);
  const [mapsApiInstance, setMapsApiInstance] = useState<any>(null);

  const handleApiLoaded = (map: any, maps: any) => {
    if (map && maps) {
      mapRef.current = map;
      mapApi.current = maps;
      setMapInstance(map);
      setMapsApiInstance(maps);
      apiReady.current = true;

      const mapOptions = {
        gestureHandling: 'greedy',
        zoom: 17,
        styles: [{ featureType: 'all', elementType: 'all', stylers: [{ visibility: 'on' }] }],
        mapTypeControl: true,
        mapTypeId: maps.MapTypeId.ROADMAP,
        mapTypeControlOptions: {
          style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: maps.ControlPosition.BOTTOM_CENTER,
          mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE],
        },
      };
      map.setOptions(mapOptions);
    }
  };

  const handleStartDateChange = (e: any) => {
    if (e.date) {
      const newStartDate = e.date.toDate().toISOString().split('T')[0];
      const newEndDate = new Date(newStartDate);
      newEndDate.setFullYear(newEndDate.getFullYear() + 1);
      newEndDate.setDate(newEndDate.getDate() - 1);
      setFormData((prev) => ({ ...prev, startDate: newStartDate, endDate: newEndDate.toISOString().split('T')[0] }));
    }
  };

  const handleEndDateChange = (e: any) => {
    if (e.date) {
      const newEndDate = e.date.toDate().toISOString().split('T')[0];
      setFormData((prev) => ({ ...prev, endDate: newEndDate }));
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [url, setUrl] = useState('');
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const signRef = useRef<SignatureCanvas | null>(null);
  const [signature2, setSignature2] = useState('');
  const [showSignature2Modal, setShowSignature2Modal] = useState(false);
  const signRef2 = useRef<SignatureCanvas | null>(null);

  const handleShowSignatureModal = () => setShowSignatureModal(true);
  const handleCloseSignatureModal = () => setShowSignatureModal(false);
  const handleGenerateSignature = () => {
    if (signRef.current) {
      const signatureDataUrl = signRef.current.getTrimmedCanvas().toDataURL('image/png');
      setUrl(signatureDataUrl);
      handleCloseSignatureModal();
    }
  };
  const handleClearSignature = () => {
    if (signRef.current) { signRef.current.clear(); setUrl(''); }
  };

  const handleShowSignature2Modal = () => setShowSignature2Modal(true);
  const handleCloseSignature2Modal = () => setShowSignature2Modal(false);
  const handleGenerateSignature2 = () => {
    if (signRef2.current) {
      const signatureDataUrl = signRef2.current.getTrimmedCanvas().toDataURL('image/png');
      setSignature2(signatureDataUrl);
      handleCloseSignature2Modal();
    }
  };
  const handleClearSignature2 = () => {
    if (signRef2.current) { signRef2.current.clear(); setSignature2(''); }
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!isFormValid()) {
      toast.error('กรุณากรอกข้อมูลให้ครบถ้วน');
      return;
    }
    const dataToSubmit = { ...formData, signature: url, signature2: signature2 || '' };
    try {
      const response = await submitFormReNewShopData(dataToSubmit);
      if (response.status === false) {
        toast.error(response.message || 'เกิดข้อผิดพลาดในการบันทึก');
      } else {
        toast.success('บันทึกข้อมูลสำเร็จ!');
        navigate('/fp-me?shop_id=' + response.shopId);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      toast.error('เกิดข้อผิดพลาดในการบันทึกข้อมูล');
    }
  };

  return (
    <div>
      <style dangerouslySetInnerHTML={{ __html: autocompleteStyles }} />
      <ContentHeader title="FastPrint Team ต่ออายุร้านค้า" />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <Card className="mt-0">
                <Card.Body>
                  <Form onSubmit={handleSubmit}>
                    <div className="row">
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Control
                          type="text"
                          placeholder="ค้นหาร้านค้า (ชื่อร้านค้า, เลขประจำตัวผู้เสียภาษี, ผู้กระทำการแทน)"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleSearch();
                            }
                          }}
                        />
                      </Form.Group>
                      <Form.Group className="col-md-4">
                        <Button variant="primary" onClick={handleSearch}>ค้นหา</Button>
                      </Form.Group>
                    </div>

                    <Modal show={showSearchModal} onHide={() => setShowSearchModal(false)} size="lg" className="responsive-modal">
                      <Modal.Header closeButton>
                        <Modal.Title>ผลการค้นหา</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <div className="row" style={{ overflowX: 'auto', overflowY: 'hidden', width: '100%' }}>
                          <div className="col-12" style={{ minWidth: '1000px', maxWidth: '100%' }}>
                            <div className="table-responsive">
                              <Table striped bordered hover className="w-100">
                                <thead>
                                  <tr>
                                    <th>เลือก</th>
                                    <th>พิมพ์</th>
                                    <th>ชื่อร้านค้า</th>
                                    <th>เลขผู้เสียภาษี</th>
                                    <th>บุคคลติดต่อ</th>
                                    <th>ปีเดือนเริ่มสัญญา</th>
                                    <th>ชื่อ CD</th>
                                    <th>สถานะ</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {searchResults && searchResults.length > 0 ? (
                                    searchResults.map((shop: any, index: number) => (
                                      <tr key={index}>
                                        <td>
                                          {shop.STATUS === 'AP' ? (
                                            <Button variant="primary" size="sm" onClick={() => handleSelectShop(shop)}>เลือก</Button>
                                          ) : <span className="text-muted"></span>}
                                        </td>
                                        <td>
                                          {shop.STATUS === 'AP' || shop.STATUS === 'WA' ? (
                                            <a className="btn btn-outline-success btn-sm" id={`${shop.SHOP_ID}_pnt`} target="_blank" rel="noreferrer"
                                              href={`https://api-zoom-v2.advanceagro.net/pdfapi/fastprint/${shop.SHOP_ID}/${user.ID_EMP}?t=${_tk}`}>
                                              <i className="fas fa-print"></i>
                                            </a>
                                          ) : <span className="text-muted"> </span>}
                                        </td>
                                        <td style={{ width: 150 }}>{shop.SHOP_NAME_TH || '-'}</td>
                                        <td>{shop.ID_TAX || '-'}</td>
                                        <td>{shop.CONTACT_NAME_TH || '-'}</td>
                                        <td>{shop.DATE_START ? shop.DATE_START.slice(0, 7).replace('-', '/') : '-'}</td>
                                        <td>{shop.BY_NAME || '-'}</td>
                                        <td>{shop.STATUS || '-'}</td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr><td colSpan={7} className="text-center text-muted">❌ ไม่พบข้อมูลร้านค้า</td></tr>
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        </div>
                      </Modal.Body>
                    </Modal>

                    {/* ชื่อนิติบุคคล/ชื่อบุคคล */}
                    <div className="row">

                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>SHOP ID</Form.Label>
                        <Form.Control
                          type="text"
                          name="shopIdOld"
                          placeholder="เลขประจำร้าน"
                          value={formData.shopIdOld}
                          readOnly
                        />
                      </Form.Group>

                    </div>
                    <div className="row">
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ชื่อนิติบุคคล/ชื่อบุคคล</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="ชื่อนิติบุคคล/ชื่อบุคคล"
                          value={formData.name}
                          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                          required
                          style={{
                            borderColor: errorFields.includes("name") ? "red" : "",
                          }}
                        />
                      </Form.Group>


                      {/* เลขผู้เสียภาษี/เลขบัตรประชาชน */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>เลขผู้เสียภาษี/เลขบัตรประชาชน</Form.Label>
                        <Form.Control
                          type="text"
                          name="taxId"
                          placeholder="เลขผู้เสียภาษี/เลขบัตรประชาชน"
                          value={formData.taxId}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                              handleChange(e);
                            }
                          }}
                          pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                          required
                        />
                      </Form.Group>

                      {/* ชื่อจุดติดตั้ง/ชื่อร้านค้า */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ชื่อจุดติดตั้ง/ชื่อร้านค้า</Form.Label>
                        <Form.Control
                          type="text"
                          name="installationPoint"
                          placeholder="ชื่อจุดติดตั้ง/ชื่อร้านค้า"
                          value={formData.installationPoint}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="row">
                      {/* ผู้กระทำการแทน */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ผู้กระทำการแทน</Form.Label>
                        <Form.Control
                          type="text"
                          name="contactPerson"
                          placeholder="ผู้กระทำการแทน"
                          value={formData.contactPerson}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>

                      {/* เบอร์โทรศัพท์ */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>เบอร์โทรศัพท์</Form.Label>
                        <Form.Control
                          type="tel"
                          name="phone"
                          placeholder="เบอร์โทรศัพท์"
                          value={formData.phone}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                              handleChange(e);
                            }
                          }}
                          pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                          required
                        />
                      </Form.Group>

                      {/* อีเมล์ */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>อีเมล์</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="อีเมล์"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="row">
                      {/* บุคคลติดต่อ2 */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ผู้ติดต่อประสานงาน(ชื่อและเบอร์โทร)</Form.Label>
                        <Form.Control
                          type="text"
                          name="contactPerson2"
                          placeholder="ผู้ติดต่อประสานงาน"
                          value={formData.contactPerson2}
                          onChange={handleChange}
                        // required
                        />
                      </Form.Group>
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>วันทำการ</Form.Label>
                        <Form.Control
                          as="select"
                          name="workDays"
                          value={formData.workDays}
                          onChange={handleChange}
                          style={{
                            borderColor: errorFields.includes("workDays") ? "red" : "",
                          }}
                        >
                          <option value="">-- กรุณาเลือกวันทำการ --</option>
                          {dropdownData.SHOP_WORKING_DAY.DATA.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                      {/* เวลา */}

                      <Form.Group className="mb-3 col-md-2">
                        <Form.Label>เวลาเปิดเครื่อง</Form.Label>
                        <TimePicker
                          date={formData.workHourStart} // ✅ ใช้ค่าเวลาเดิม
                          format="HH:mm" // ✅ แสดงแค่ "ชั่วโมง:นาที"
                          onChange={(e) => {
                            if (e?.date) {
                              const newWorkHourStart = e.date.format("HH:mm"); // ✅ แปลงเป็นรูปแบบเวลา HH:mm
                              setFormData((prevState) => ({
                                ...prevState,
                                workHourStart: newWorkHourStart, // ✅ อัปเดตเฉพาะเวลา
                              }));
                            }
                          }}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3 col-md-2">
                        <Form.Label>เวลาปิดเครื่อง</Form.Label>
                        <TimePicker
                          date={formData.workHourEnd} // ✅ ใช้ค่าเวลาเดิม
                          format="HH:mm" // ✅ แสดงแค่ "ชั่วโมง:นาที"
                          onChange={(e) => {
                            if (e?.date) {
                              const newWorkHourEnd = e.date.format("HH:mm"); // ✅ แปลงเป็นรูปแบบเวลา HH:mm
                              setFormData((prevState) => ({
                                ...prevState,
                                workHourEnd: newWorkHourEnd, // ✅ อัปเดตเฉพาะเวลา
                              }));
                            }
                          }}
                        />
                      </Form.Group>
                    </div>
                    {/* ที่อยู่ตามบัตรประชาชน/ภพ20 */}
                    <Form.Group className="mb-3">
                      <Form.Label>ที่อยู่ตามบัตรประชาชน/ภ.พ.20</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="addressByIdCard"
                        placeholder="กรอกที่อยู่ตามบัตรประชาชน/ภ.พ.20"
                        value={formData.addressByIdCard}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>

                    {/* GPS Location */}
                    <div className="row">
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>GPS Location</Form.Label>
                        <div className="input-group">
                          {/* Input Field */}
                          <Form.Control
                            type="text"
                            name="gpsLocation"
                            placeholder="กรุณากดเลือกตำแหน่งบนแผนที่"
                            value={formData.gpsLocation}
                            readOnly
                            style={{
                              borderColor: errorFields.includes("gpsLocation") ? "red" : "",
                            }}
                          />
                          {/* Button with Icon */}
                          <button
                            type="button"
                            className="btn btn-outline-secondary"
                            onClick={() => setShowMap(true)}
                            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          >
                            <FontAwesomeIcon icon={fas.faLocationDot} />
                          </button>
                        </div>
                      </Form.Group>

                      {/* Modal สำหรับเลือกตำแหน่งแผนที่ */}
                      <Modal show={showMap} onHide={() => setShowMap(false)} size="lg" centered>
                        <Modal.Header closeButton>
                          <Modal.Title>เลือกตำแหน่งบนแผนที่</Modal.Title>
                        </Modal.Header>
                        <div className="map-search-container">
                            <SearchBox
                              map={mapInstance}
                              mapApi={mapsApiInstance}
                              addplace={(place: any) => {
                                if (!place || !place.geometry) return;
                                const lat = place.geometry.location.lat();
                                const lng = place.geometry.location.lng();
                                if (mapRef.current?.panTo) mapRef.current.panTo({ lat, lng });
                                if (mapRef.current?.setZoom) mapRef.current.setZoom(17);
                                setMyposition((prev) => ({ ...prev, center: { lat, lng }, zoom: 17 }));
                                setFormData((prev) => ({ ...prev, gpsLocation: `${lat.toFixed(6)},${lng.toFixed(6)}` }));
                              }}
                            />
                          </div>
                        <Modal.Body>
                          
                          <div ref={mapContainerRef} id="map-container" style={{ height: isFullscreen ? "100vh" : "60vh", width: "100%", position: "relative" }}>
                            <GoogleMapReact
                              bootstrapURLKeys={{ key: 'AIzaSyB88aLnfSb_Fe1_q8483R6_jcZjKznODWo', libraries: ['places', 'geometry'] }}
                              center={myposition.center}
                              defaultZoom={myposition.zoom}
                              yesIWantToUseGoogleMapApiInternals
                              onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
                              onClick={handleMapClick}
                            >
                              <Marker lat={myposition.center.lat} lng={myposition.center.lng} />
                            </GoogleMapReact>

                            <button onClick={toggleFullscreen} style={{ position: "absolute", top: "10px", right: "10px", background: "white", border: "1px solid #ccc", padding: "8px", borderRadius: "5px", cursor: "pointer" }}>
                              {isFullscreen ? "ออกจาก Fullscreen" : "Fullscreen"}
                            </button>
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button variant="primary" onClick={handleConfirmLocation}>ยืนยันตำแหน่ง</Button>
                          <Button variant="secondary" onClick={() => setShowMap(false)}>ปิด</Button>
                        </Modal.Footer>
                      </Modal>
                    
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ชนิดผลตอบแทนจ่าย</Form.Label>
                        <Form.Control
                          as="select"
                          name="rewardType"
                          value={formData.rewardType}
                          onChange={handleChange}
                          style={{
                            borderColor: errorFields.includes("rewardType") ? "red" : "",
                          }}
                        >
                          <option value="">-- กรุณาเลือกชนิดผลตอบแทนจ่าย --</option>
                          {dropdownData.PAYMENT.DATA.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>


                      {/* ชนิดร้านค้า */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ชนิดร้านค้า</Form.Label>
                        <Form.Control
                          as="select"
                          name="shopType"
                          value={formData.shopType}
                          onChange={handleChange}
                          style={{
                            borderColor: errorFields.includes("shopType") ? "red" : "",
                          }}
                        >
                          <option value="">-- กรุณาเลือกชนิดร้านค้า --</option>
                          {dropdownData.SHOP_TYPE.DATA.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </div>
                    {/* ที่อยู่จุดติดตั้ง */}
                    <Form.Group className="mb-3 md-4">
                      <Form.Label>ที่อยู่จุดติดตั้ง</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="address"
                        placeholder="ที่อยู่จุดติดตั้ง"
                        value={formData.address}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                    <div className="row">

                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ประมาณการวันที่ติดตั้ง</Form.Label>
                        <DateTimePicker
                          date={formData.installDate ? new Date(formData.installDate) : new Date()}
                          format="YYYY-MM-DD"
                          onChange={(e) => {
                            if (e && e.date) {
                              const selectedDate = e.date.toISOString().split('T')[0];
                              setFormData((prev) => ({
                                ...prev,
                                DATE_INSTALL: selectedDate,
                              }));
                            }
                          }}
                        />
                      </Form.Group>


                      {/* ค่าเช่า */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>ค่าเช่า</Form.Label>
                        <Form.Control
                          type="number"
                          name="rentalFee"
                          placeholder="ค่าเช่า"
                          value={formData.rentalFee}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                              handleChange(e);
                            }
                          }}
                          pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                          required
                        />
                      </Form.Group>

                      {/* เลือก MSD */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>เลือก MSD</Form.Label>
                        <Form.Control
                          as="select"
                          name="msd"
                          value={formData.msd}
                          onChange={handleChange}
                          style={{
                            borderColor: errorFields.includes("msd") ? "red" : "",
                          }}
                        >
                          <option value="">-- กรุณาเลือก MSD --</option>
                          {dropdownData.MSD.DATA.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>
                    </div>
                    <div className="row">
                      {/* จำนวนเครื่อง */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>จำนวนเครื่อง</Form.Label>
                        <Form.Control
                          type="number"
                          name="machinesNumber"
                          placeholder="จำนวนเครื่อง"
                          value={formData.machinesNumber}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                              handleChange(e);
                            }
                          }}
                          pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                          required
                        />
                      </Form.Group>
                      {/* วันที่เริ่มต้นสัญญา */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>วันที่เริ่มต้นสัญญา</Form.Label>
                        <DateTimePicker
                          date={formData.startDate}
                          format="YYYY-MM-DD"
                          onChange={handleStartDateChange}
                        />
                      </Form.Group>

                      {/* วันที่สิ้นสุดสัญญา */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>วันที่สิ้นสุดสัญญา</Form.Label>
                        <DateTimePicker
                          date={formData.endDate}
                          format="YYYY-MM-DD"
                          onChange={handleEndDateChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="row">
                      {/* เลือกธนาคาร */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>เลือกธนาคาร</Form.Label>
                        <Form.Control
                          as="select"
                          name="bank"
                          value={formData.bank}
                          onChange={handleChange}
                          style={{
                            borderColor: errorFields.includes("bank") ? "red" : "",
                          }}
                        >
                          <option value="">-- กรุณาเลือกธนาคาร --</option>
                          {dropdownData.BANK.DATA.map((item, index) => (
                            <option key={index} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>


                      {/* เลขที่บัญชีธนาคาร */}
                      <Form.Group className="mb-3 col-md-4">
                        <Form.Label>เลขที่บัญชีธนาคาร</Form.Label>
                        <Form.Control
                          type="text"
                          name="bankAccount"
                          placeholder="เลขที่บัญชีธนาคาร"
                          value={formData.bankAccount}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) { // ตรวจสอบให้เป็นตัวเลขเท่านั้น
                              handleChange(e);
                            }
                          }}
                          pattern="\d*" // HTML pattern ให้พิมพ์ได้เฉพาะตัวเลข
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="row p-0">
                      {/* การรับรู้และลายเซ็น */}
                      <div className="col-md-6 col-12 m-0">
                        <Card className="m-0 col-md-12">

                          <Card.Header>ลงนามผู้กระทำการแทน</Card.Header>
                          <Card.Body>
                            <div
                              id="signature-area"
                              className="mt-3 position-relative"
                              style={{
                                width: '100%',
                                height: '150px',
                                border: '1px solid gray',
                                backgroundColor: 'white',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {/* ปุ่ม "ลงนาม" */}
                              <button
                                className="btn btn-secondary"
                                type="button"
                                onClick={handleShowSignatureModal}
                                style={{
                                  zIndex: 1, // ทำให้ปุ่มแสดงอยู่ข้างบนเสมอ

                                }}
                              >
                                <i className="fa fa-pencil"></i> ลงนาม
                              </button>

                              {/* แสดงภาพลายเซ็นเมื่อมีการเซ็นแล้ว */}
                              {url && (
                                <img
                                  src={url} // แสดงลายเซ็นคนที่สอง
                                  alt="ลายเซ็นผู้กระทำการแทน"
                                  style={{
                                    maxWidth: '100%', // ปรับขนาดลายเซ็นให้อยู่ในกรอบ
                                    maxHeight: '100%', // ปรับขนาดลายเซ็นให้อยู่ในกรอบ
                                    display: url ? 'block' : 'none', // ซ่อนหากยังไม่มีลายเซ็น
                                  }}
                                />
                              )}
                            </div>
                          </Card.Body>
                        </Card>
                      </div>
                      <div className="col-md-6 col-12 m-0">
                        {/* การรับรู้และลายเซ็น */}
                        <Card className="m-0 col-md-12">
                          <Card.Header>ลงนามพยาน/ผู้ติดต่อประสานงาน</Card.Header>
                          <Card.Body>

                            <div
                              id="signature-area"
                              className="mt-3 position-relative"
                              style={{
                                width: '100%',
                                height: '150px',
                                border: '1px solid gray',
                                backgroundColor: 'white',
                                position: 'relative',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              {/* ปุ่ม "ลงนาม" */}
                              <button
                                className="btn btn-secondary"
                                type="button"
                                onClick={handleShowSignature2Modal}
                                style={{
                                  zIndex: 1, // ทำให้ปุ่มแสดงอยู่ข้างบนเสมอ

                                }}
                              >
                                <i className="fa fa-pencil"></i> ลงนาม
                              </button>

                              {/* แสดงภาพลายเซ็นเมื่อมีการเซ็นแล้ว */}
                              {signature2 && (
                                <img
                                  src={signature2} // แสดงลายเซ็นคนที่สอง
                                  alt="ลายเซ็นพยาน/บุคคลติดต่อคนที่สอง"
                                  style={{
                                    maxWidth: '100%', // ปรับขนาดลายเซ็นให้อยู่ในกรอบ
                                    maxHeight: '100%', // ปรับขนาดลายเซ็นให้อยู่ในกรอบ
                                    display: signature2 ? 'block' : 'none', // ซ่อนหากยังไม่มีลายเซ็น
                                  }}
                                />
                              )}
                            </div>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                    <Button
                      className="mt-3"
                      type="submit"
                      disabled={!url}
                      variant={!url ? 'secondary' : 'primary'}
                    >
                      {!url ? 'บันทึกข้อมูล' : 'บันทึกข้อมูล'}
                    </Button>

                  </Form>
                  {/* {_tk} */}

                  {/* {response && (
                    <div className="mt-4">
                      <h5>Response:</h5>
                      <pre>{JSON.stringify(response, null, 2)}</pre>
                    </div>
                  } */}
                </Card.Body>
              </Card>

              {/* Modal ลายเซ็น */}
              <Modal show={showSignatureModal} onHide={handleCloseSignatureModal}>
                <Modal.Header closeButton>
                  <Modal.Title>ลงนามผู้กระทำการแทน</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div
                    className="col-12"
                    style={{
                      border: "2px solid black",
                      width: "100%",
                      height: 200,
                    }}
                  >
                    <SignatureCanvas
                      canvasProps={{
                        width: 500,
                        height: 200,
                        className: "sigCanvas",
                      }}
                      ref={signRef}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="success" onClick={handleGenerateSignature}>
                    ใช้ลายเซ็นนี้
                  </Button>
                  <Button variant="warning" onClick={handleClearSignature}>
                    เซ็นใหม่
                  </Button>
                </Modal.Footer>
              </Modal>
              {/* Modal ลายเซ็น */}
              <Modal show={showSignature2Modal} onHide={handleCloseSignature2Modal}>
                <Modal.Header closeButton>
                  <Modal.Title>ลงนามพยาน/ผู้ติดต่อประสานงาน</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div
                    className="col-12"
                    style={{
                      border: "2px solid black",
                      width: "100%",
                      height: 200,
                    }}
                  >
                    <SignatureCanvas
                      canvasProps={{
                        width: 500,
                        height: 200,
                        className: "sigCanvas",
                      }}
                      ref={signRef2}
                    />
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="success" onClick={handleGenerateSignature2}>
                    ใช้ลายเซ็นนี้
                  </Button>
                  <Button variant="warning" onClick={handleClearSignature2}>
                    เซ็นใหม่
                  </Button>
                </Modal.Footer>
              </Modal>



            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
<link
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css"
  rel="stylesheet"
/>